import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Alert from '@material-ui/lab/Alert';
import {DropzoneAreaBase} from 'material-ui-dropzone'
const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  DialogForm: {
    width: "100%",
    marginTop: "1rem",
    marginBottom: "1rem"
  },
  buttonItem: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '1rem'
  },
  formItem: {
      paddingBottom: '1rem'
  },
  TextField: {
      width: "100%"
  },
  loading: {
    border: '10px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '10px solid #3498db',
    width: '100px !important',
    height: '100px',
    animation: '$spin 2s linear infinite'
  },
  '@-webkit-keyframes spin': {
    '0%': {
        webkitTransform: 'rotate(0deg)'
    },
    '100%': {
        webkitTransform: 'rotate(360deg)'
    }
  },
  '@keyframes spin': {
      '0%': {
          transform: 'rotate(0deg)'
      },
      '100%': {
          transform: 'rotate(360deg)'
      }
  }
}));

export default function BulkUpdate(props) {
    const classes = useStyles();
    let NewDate = new Date();
    let CurrentYear = NewDate.getFullYear();
    const [updateType, setUpdateType] = useState('scrap');
    const [department, setDepartment] = useState('None');
    const [room, setRoom] = useState('None');
    const [subState, setSubState] = useState('');
    const [subStateId, setSubStateId] = useState('');
    const [site, setSite] = useState('');
    const [csvData, setCSVData] = useState('');
    const [disposalInfo, setDisposalInfo] = useState('');
    const [disposalDate, setDisposalDate] = useState(CurrentYear + '-01-01');
    const [returnDate, setReturnDate] = useState(CurrentYear + '-01-01');
    const [loading, setLoading] = useState();
    const [departmentUI, setDepartmentUI] = useState();
    const [roomUI, setRoomUI] = useState();
    const [alert, setAlert] = useState();
    const [error, setError] = useState(false);
    const handleDropdownChange = async (event, key) => {
        switch(event.target.name)
        {
            case "ddlUpdateType":
                setUpdateType(event.target.value);
                if(event.target.value === "department")
                {
                    const requestOptions = {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    };
                    fetch("https://lapsafeapi.azurewebsites.net/api/bulkupdate/department?HornbillKey=zmn2DSx8a7884Y", requestOptions).then(response => response.json()).then((data) => {
                        setDepartmentUI(<>
                            <Grid item className={classes.formItem} xs={12}>
                                <InputLabel htmlFor="ddlDepartment">Department</InputLabel>
                                <Select name="ddlDepartment" id="ddlDepartment" className={classes.DialogForm} defaultValue="none" onChange={handleDropdownChange}>
                                    <MenuItem value="none">
                                        None
                                    </MenuItem>
                                    {data.map((department) => {
                                        return (<MenuItem key={department.key} value={department.value}>
                                            {department.value}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </Grid>
                        </>);
                    });
                }
                else if(event.target.value === "room")
                {
                    const requestOptions = {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    };
                    const siteData = await fetch("https://lapsafeapi.azurewebsites.net/api/bulkupdate/site?HornbillKey=zmn2DSx8a7884Y", requestOptions).then(response => response.json()).then((sitedata) => {return sitedata});
                    fetch("https://lapsafeapi.azurewebsites.net/api/bulkupdate/state?HornbillKey=zmn2DSx8a7884Y", requestOptions).then(response => response.json()).then((statedata) => {
                        setRoomUI(<>
                            <Grid item className={classes.formItem} xs={12}>
                                <InputLabel htmlFor="ddlSite">Site</InputLabel>
                                <Select name="ddlSite" id="ddlSite" className={classes.DialogForm} defaultValue="none" onChange={handleDropdownChange}>
                                    <MenuItem value="none">
                                        None
                                    </MenuItem>
                                    {siteData.map((site) => {
                                        return (<MenuItem key={site.key} value={site.key}>
                                            {site.key}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </Grid>
                            <Grid item className={classes.formItem} xs={12}>
                                <InputLabel htmlFor="ddlState">State</InputLabel>
                                <Select name="ddlState" id="ddlState" className={classes.DialogForm} defaultValue="none" onChange={handleDropdownChange}>
                                    <MenuItem value="none">
                                        None
                                    </MenuItem>
                                    {statedata.map((state) => {
                                        return (<MenuItem key={state.key} value={state.value}>
                                            {state.value}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </Grid>
                            <Grid item className={classes.formItem} xs={12}>
                                <TextField className={classes.TextField} id="room" variant="outlined" onChange={handleTextChange} type="string" label="Room"/>
                            </Grid>
                        </>);
                    });
                }
                break;
            case "ddlState":
                var StateKey = key.key;
                setSubState(event.target.value);
                setSubStateId(StateKey.substring(StateKey.indexOf('$') + 1));
                break;
            case "ddlSite":
                setSite(event.target.value);
                break;
            case "ddlDepartment":
                setDepartment(event.target.value);
                break;
            default:
        }        
    };
    const handleTextChange = (event, value) => {
        switch(event.target.id)
        {
            case "disposalinfo":
                setDisposalInfo(event.target.value);
                break;
            case "returndate":
                setReturnDate(event.target.value);
                break;
            case "room":
                setRoom(event.target.value);
                break;
            default:
                setDisposalDate(event.target.value);
        }
    };
    const handleSaveCSV = (files) => {
        var Base64CSVFile = {csv: files[0].data.substr(files[0].data.indexOf(',') + 1)};
        setCSVData(Buffer.from(Base64CSVFile.csv, "base64").toString());
    };
    const updateAssets = () => {
        if(updateType === "scrap" && disposalInfo === "")
        {
            setError(true); 
            return;
        }
        setLoading(<Container className={classes.loading}></Container>);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updatemethod: updateType,
                csvdata: csvData,
                disposalinfo: disposalInfo,
                disposaldate: disposalDate,
                returndate: returnDate,
                department: department,
                room: room,
                substate: subState,
                substateid: subStateId,
                site: site
            })
        };
        fetch("https://lapsafeapi.azurewebsites.net/api/bulkupdate?HornbillKey=zmn2DSx8a7884Y", requestOptions).then(response => response.json()).then((data) => {
            if(data.Message === "Devices have now been updated in Hornbill")
            {
                setAlert(<Alert severity="success">{data.Message}</Alert>);
            }
            else if(data.Message.startsWith("The following assets failed: "))
            {
                setAlert(<Alert severity="warning">{data.Message}</Alert>);
            }
            else
            {
                setAlert(<Alert severity="error">{data.message}</Alert>);
            }
            setLoading();
            setCSVData('');
        });
    };
    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
                <Paper className={classes.paper}>
                    <Typography variant="h4">Bulk Update - Hornbill Assets</Typography>
                    <Container className={classes.container} maxWidth={false}>
                        <Grid container>
                            <Grid item className={classes.formItem} xs={12}>
                                <InputLabel htmlFor="ddlUpdateType">Update Type</InputLabel>
                                <Select name="ddlUpdateType" id="ddlUpdateType" className={classes.DialogForm} defaultValue="scrap" onChange={handleDropdownChange}>
                                    <MenuItem value="scrap">
                                        Scrap/WEEE
                                    </MenuItem>
                                    <MenuItem value="leased">
                                        Leased
                                    </MenuItem>
                                    <MenuItem value="missing">
                                        Missing
                                    </MenuItem>
                                    <MenuItem value="department">
                                        Department
                                    </MenuItem>
                                    <MenuItem value="returndate">
                                        Retire Date
                                    </MenuItem>
                                    <MenuItem value="room">
                                        Room
                                    </MenuItem>
                                </Select>
                            </Grid>
                            <Grid item className={classes.formItem} xs={12}>
                                <DropzoneAreaBase acceptedFiles={[".csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values"]} showPreviews={true} dropzoneText='' filesLimit={1} onAdd={(fileObjs) => handleSaveCSV(fileObjs)}/>
                            </Grid>
                            {updateType === "scrap" ? <>
                            <Grid item className={classes.formItem} xs={12}>
                                <TextField className={classes.TextField} variant="outlined" onChange={handleTextChange} type="date" defaultValue={CurrentYear + "-01-01"} label="Disposal Date"/>
                            </Grid>
                            <Grid item className={classes.formItem} xs={12}>
                                <TextField className={classes.TextField} variant="outlined" name="disposalinfo" error={error} label="Disposal Reason" id="disposalinfo" onChange={handleTextChange}/>
                            </Grid></> : updateType === "department" ? departmentUI : updateType === "returndate" ? <>
                            <Grid item className={classes.formItem} xs={12}>
                                <TextField className={classes.TextField} id="returndate" variant="outlined" onChange={handleTextChange} type="date" defaultValue={CurrentYear + "-01-01"} label="Return Date"/>
                            </Grid>
                            </> : updateType === "room" ? roomUI : ""
                            }
                            <Grid item xs={12} className={classes.buttonItem}>
                                <Button  variant="contained" color="primary" type="button" onClick={updateAssets}>Update Assets</Button>
                            </Grid>
                        </Grid>
                    </Container>
                    {loading}
                    {alert}
                </Paper>
            </Container>
        </main>
    )
}
